import { render, staticRenderFns } from "./ScenarioPie.vue?vue&type=template&id=6c837925"
import script from "./ScenarioPie.vue?vue&type=script&lang=js"
export * from "./ScenarioPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports